var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0E5AA7",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.985 29.1371C29.9414 28.4712 29.7889 27.817 29.5335 27.2005C29.2012 26.4005 28.6539 25.7081 27.9522 25.2001C27.4097 24.7932 26.7829 24.5129 26.118 24.3797C24.9713 24.2509 23.8492 23.9574 22.7863 23.5084C22.7133 23.4578 22.6429 23.4035 22.5754 23.3458C24.5708 21.8891 25.7126 19.5367 25.6226 17.0677C25.6226 13.1644 23.1052 10 19.9999 10C16.8946 10 14.3772 13.1644 14.3772 17.0677C14.2872 19.5371 15.4295 21.8899 17.4255 23.3464C17.3583 23.4039 17.2881 23.458 17.2153 23.5084C16.1524 23.9574 15.0303 24.2508 13.8837 24.3797C13.2187 24.513 12.592 24.7933 12.0493 25.2001C11.3477 25.7081 10.8004 26.4005 10.4682 27.2005C10.2127 27.817 10.0602 28.4712 10.0166 29.1371C9.99719 29.4244 9.99707 29.7127 10.0162 30H30C30 30 29.9884 29.1834 29.985 29.1371Z",
    fill: "#0E5AA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/AccountCircle.7aea29ff23087e5028bc5918c74ff147.svg";
export { ForwardRef as ReactComponent };